import React from 'react';
import MuiButton from '@mui/material/Button';
// import { ButtonProps } from './types';

export const Button: React.FC<any> = ({ ...props }) => {
  if (props.customizerEnabled === undefined) props.customizerEnabled = true;

  return <MuiButton {...props} />;
};
